import { TPreviousExperience } from '../../apis/staff/staff.interfaces';

export const mockStaffPreviousExperience: TPreviousExperience[] = [
  {
    company: 'ABC School',
    role: 'Mathematics Teacher',
    from: '2018-06-01',
    to: '2020-05-31',
    description:
      'Taught mathematics for grades 6-10. Led the math olympiad team.',
  },
  {
    company: 'XYZ Academy',
    role: 'Senior Teacher',
    from: '2015-08-01',
    to: '2018-05-31',
    description: 'Handled curriculum development and teacher training.',
  },
];
